__turbopack_context__.v({
  "collapsed": "ExpandableDescription-module-scss-module__UNGduG__collapsed",
  "content": "ExpandableDescription-module-scss-module__UNGduG__content",
  "gradient": "ExpandableDescription-module-scss-module__UNGduG__gradient",
  "root": "ExpandableDescription-module-scss-module__UNGduG__root",
  "toggleBtn": "ExpandableDescription-module-scss-module__UNGduG__toggleBtn",
});
